import * as tslib_1 from "tslib";
import { Directive, HostListener, ElementRef, Renderer2, Optional, HostBinding, Input } from "@angular/core";
import { DragResizeService } from './../drag-resize.service';
import { Button } from '@progress/kendo-angular-buttons';
import { L10N_PREFIX, LocalizationService } from '@progress/kendo-angular-l10n';
var WindowMinimizeActionDirective = /** @class */ (function (_super) {
    tslib_1.__extends(WindowMinimizeActionDirective, _super);
    function WindowMinimizeActionDirective(el, renderer, _service, localization) {
        var _this = _super.call(this, el, renderer, null, localization) || this;
        _this.window = _service;
        _this.look = 'bare';
        _this.icon = 'window-minimize';
        return _this;
    }
    WindowMinimizeActionDirective.prototype.onClick = function () {
        if (!this.isDisabled) {
            this.window.minimizeAction();
        }
    };
    Object.defineProperty(WindowMinimizeActionDirective.prototype, "visible", {
        get: function () {
            return this.window.options.state === 'default' ? 'inline-flex' : 'none';
        },
        enumerable: true,
        configurable: true
    });
    WindowMinimizeActionDirective.decorators = [
        { type: Directive, args: [{
                    exportAs: 'kendoWindowMinimizeAction',
                    providers: [
                        LocalizationService,
                        {
                            provide: L10N_PREFIX,
                            useValue: 'kendo.button'
                        }
                    ],
                    selector: 'button[kendoWindowMinimizeAction]' // tslint:disable-line
                },] },
    ];
    /** @nocollapse */
    WindowMinimizeActionDirective.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
        { type: DragResizeService, decorators: [{ type: Optional },] },
        { type: LocalizationService, },
    ]; };
    WindowMinimizeActionDirective.propDecorators = {
        'window': [{ type: Input },],
        'onClick': [{ type: HostListener, args: ['click',] },],
        'visible': [{ type: HostBinding, args: ['style.display',] },],
    };
    return WindowMinimizeActionDirective;
}(Button));
export { WindowMinimizeActionDirective };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-dialog/dist/es/window/actions/window-minimize-action.directive.js
// module id = ../../../../@progress/kendo-angular-dialog/dist/es/window/actions/window-minimize-action.directive.js
// module chunks = vendor